var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArtTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 26,
    viewBox: "0 0 42 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4987 25.8332C3.49036 25.8332 2.62717 25.4741 1.90911 24.7561C1.19106 24.038 0.832031 23.1748 0.832031 22.1665V3.83317C0.832031 2.82484 1.19106 1.96164 1.90911 1.24359C2.62717 0.525532 3.49036 0.166504 4.4987 0.166504H22.832C23.8404 0.166504 24.7036 0.525532 25.4216 1.24359C26.1397 1.96164 26.4987 2.82484 26.4987 3.83317V22.1665C26.4987 23.1748 26.1397 24.038 25.4216 24.7561C24.7036 25.4741 23.8404 25.8332 22.832 25.8332H4.4987ZM4.4987 22.1665H22.832V3.83317H4.4987V22.1665ZM6.33203 18.4998H20.9987L16.232 12.0832L12.7487 16.6665L10.182 13.2748L6.33203 18.4998ZM30.1654 25.8332V0.166504H33.832V25.8332H30.1654ZM37.4987 25.8332V0.166504H41.1654V25.8332H37.4987Z",
    fill: "#484D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArtTrack);
export default __webpack_public_path__ + "static/media/icon_art_track.63f24ed13233dcd59a6deeccce3d7d6c.svg";
export { ForwardRef as ReactComponent };